import { Api } from "../api/Api";
import { paramIds } from "../api/ApiUtil";
import { AerialImage, ObbDet } from "../api/Application";
import { LoaderFunctionArgs } from "react-router-dom";
import { fileUrl } from "../api/Url";

export interface DetectionLoaderData {
    image: AerialImage;
    vehicles: ObbDet[];
}

interface JsonDetection {
    center: {
        x: number;
        y: number;
    };
    width:   number;
    height:  number;
    theta:   number;
    label:   number;
    score:   number;
    polygon: number[][];
}

function parseJsonDetection( det: JsonDetection, index: number ): ObbDet {
    return {
        obbDetId:   index,
        obbRunId:   -1,
        obbModelId: 1,
        obbClassId: Math.floor( det.label ),
        x:          det.center.x,
        y:          det.center.y,
        width:      det.width,
        height:     det.height,
        angle:      det.theta,
        confidence: det.score,
    };
}

export async function detectionLoaderFromFile( { params }: LoaderFunctionArgs ): Promise<DetectionLoaderData> {
    const { aerialImageId, file } = paramIds( params );
    const aerialImg = await Api.aerialImageGet( aerialImageId );
    if( !aerialImg.isOk ) {
        throw new Error( "Failed to fetch image. Make sure you are logged in." );
    }
    const response = await fetch( fileUrl( 'external/bspline.json' ) );
    if( !response.ok ) {
        throw new Error( "Failed to fetch detections JSON file." );
    }
    const detections: JsonDetection[] = await response.json();
    const image = aerialImg.value;
    const vehicles = detections.map( parseJsonDetection );
    return {
        image: image,
        vehicles: vehicles
    };
}